import CONFIG from '../utils/config';

import pickBy from 'lodash/pickBy';
import identity from 'lodash/identity';

export const GET_POSTS = 'loading/siteWideBanner/GET_POSTS';

export function getSiteWideBanner() {
  return async (dispatch, getState) => {
    const state = getState();

    const myHeaders = new Headers();

    return fetch(`${CONFIG.API_URI}/v1/siteWideBanner/`, {
      method: 'GET',
      headers: myHeaders,
    })
      .then(async function (response) {
        if (response.status !== 200) {
          throw new Error(response.error);
        }
        return response.json();
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  };
}

export function createSiteWideBanner(obj) {
  return (dispatch, getState) => {
    const state = getState();
    let details = pickBy(obj, identity);

    let formBody = new URLSearchParams();
    for (var property in details) {
      formBody.set(property, details[property]);
    }

    return fetch(`${CONFIG.API_URI}/v1/siteWideBanner/`, {
      method: 'POST',
      body: formBody,
      credentials: 'include',
    })
      .then(function (response) {
        if (response.status !== 201) {
          throw new Error(response.error);
        }
        return response.json();
      })
      .then((post) => {
        dispatch({
          type: GET_POSTS,
          payload: {
            posts: [post],
          },
        });
        return post;
      })
      .catch((err) => {
        return err;
      });
  };
}

export function updateSiteWideBanner(obj, postId) {
  return (dispatch, getState) => {
    const state = getState();

    var details = obj;

    let formBody = new URLSearchParams();
    for (var property in details) {
      formBody.set(property, details[property]);
    }

    return fetch(`${CONFIG.API_URI}/v1/siteWideBanner/${postId}`, {
      method: 'PATCH',
      body: formBody,
      credentials: 'include',
    })
      .then(function (response) {
        if (response.status !== 200) {
          throw new Error(response.error);
        }
        return response.json();
      })
      .then((post) => {
        dispatch({
          type: GET_POSTS,
          payload: {
            posts: [post],
          },
        });
        return post;
      })
      .catch((err) => {
        return err;
      });
  };
}
